export class StringUtility {
  static isEmptyOrSpaces(str: string): boolean {
    return str === null || str.match(/^ *$/) !== null;
  }

  static stringContainsItemFromArray(value: string, array: string[]): boolean {
    return array.some(item => value.includes(item));
  }
}
